import { render, staticRenderFns } from "./BucketsLoading.vue?vue&type=template&id=23c8dd04&"
import script from "./BucketsLoading.vue?vue&type=script&lang=js&"
export * from "./BucketsLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports